<template>
  <div class="web">
  <div class="pc-box">
    <!--搜索-->
    <div class="pc-search">
      <div class="pc-search-auto">
        <span>
          <img src="../../assets/logo.png">
          <em>师生互选</em>
        </span>
      </div>
    </div>
      <div class="aa">
          <div class="infobox" v-show="record.teacherCode">
            <div class="history"><h2><a href="javascript:history.back(-1);">师生互选</a>&gt;&nbsp;<a href="javascript:history.back(-1);">教师列表</a>&gt;&nbsp;教师详情</h2></div>
            <div class="info-top"  style="margin-bottom: 0">
              <van-image
                      fit="contain"
                      :src="fileDisplayPrefix + record.header"
              />
              <div class="info-r">
                <div class="lang">
                  <span>{{ record.name }}
                    <!--<em v-show="record.politicalOutlook">{{ record.politicalOutlook }}</em>-->
                  </span>
                  <span v-show="record.highestDegree">工号：{{ record.teacherCode }}</span>
                </div>
                <div class="lang">
                  <span>性别：{{getDictName(genderList, record.gender) || record.gender}}</span>
                  <span>生日：{{ record.birthday }}</span>
                </div>
                <div class="lang">
                  <span style="width: 100%" v-show="record.highestDegree" class="lang-span">最高学位：{{ record.highestAcademicDegree }}</span>
                </div>
              </div>
            </div>
            <!-- 详细信息 -->
            <div class="info-detail">
              <h2>详细信息</h2>
              <div class="tale-box">
                <table>
                  <tr>
                    <td>指导学生名额：{{ record.maxCount }}人</td>
                    <td>招生方向：{{ record.enrollmentDirection }}</td>
                    <td>导师类别：{{ record.category }}</td>
                    <td>导师类型：{{ record.teacherType }}</td>
                  </tr>
                  <tr>
                    <td>手机号：{{ record.mobileNum }}</td>
                    <td colspan="3">电子邮箱：{{ record.email }}</td>
                  </tr>
                </table>
              </div>
              <div v-show="record.professionalTitle">
                <h2>职称</h2>
                <div class="my-list">
                  {{ record.professionalTitle }}
                </div>
              </div>

              <div  v-show="record.enterprisePosition">
                <h2>企业职务</h2>
                <div class="my-list">
                  {{ record.enterprisePosition }}
                </div>
              </div>

              <div v-show="record.researchDirection">
                <h2>研究方向</h2>
                <div class="my-list">
                  {{ record.researchDirection }}
                </div>
              </div>

              <div v-show="record.learningExperience">
                <h2>学习经历</h2>
                <div class="my-list">
                  {{ record.learningExperience }}
                </div>
              </div>

              <div v-show="record.workExperience">
                <h2>工作经历</h2>
                <div class="my-list">
                  {{ record.workExperience }}
                </div>
              </div>

              <div v-show="record.deputyProject">
                <h2>代表性科研项目</h2>
                <div class="my-list">
                  {{ record.deputyProject }}
                </div>
              </div>

              <div v-show="record.deputyAchievement">
                <h2>代表性科研成果</h2>
                <div class="my-list">
                  {{ record.deputyAchievement }}
                </div>
              </div>

              <div v-show="record.honoraryAwards">
                <h2>荣誉奖励</h2>
                <div class="my-list">
                  {{ record.honoraryAwards }}
                </div>
              </div>

              <div v-show="record.workUnit">
                <h2>所在院系/工作单位</h2>
                <div class="my-list">
                  {{ record.workUnit }}
                </div>
              </div>

              <div v-show="record.remark">
                <h2>备注</h2>
                <div class="my-list">
                  {{ record.remark }}
                </div>
              </div>

              <div v-show="record.resumePath">
                <h2>简历附件</h2>
                <div class="my-list">
                  <a class="upload-a" :href="fileDisplayPrefix + record.resumePath" target="_blank">查看</a>
                  <a class="upload-a" :href="fileDisplayPrefix + record.resumePath" download="简历">下载</a>
                </div>
              </div>

              <div v-show="record.content">
                <h2>个人简介</h2>
                <div class="my-list">
                  <div v-html="record.content"></div>
                </div>
              </div>

            </div>
          </div>
          <div class="b-but fiex-box" v-if="((!record.chooseStatus && record.id) || ['2', '3', '4', '5'].includes(record.chooseStatus)) && record.selectCount < record.maxCount && !notSelect">
            <van-button style="background: #914D3B" size="small" round type="info" @click="$refs.remark.show(record.chooseRemark)">
              选择老师
            </van-button>
          </div>
      </div>
      <div class="newheight" v-if="((!record.chooseStatus && record.id) || ['2', '3', '4', '5'].includes(record.chooseStatus)) && record.selectCount < record.maxCount && !notSelect"></div>
    <remark ref="remark" title="备注" @handleOk="chooseTeacher" />
    <div class="foot">Copyright © www.senergy.sjtu.edu.cn. All Rights Reserved</div>
  </div>
  </div>
</template>

<script>
  import {FILE_DISPLAY_PREFIX} from '@/api/upload'
  import {getDictByType} from '@/api/common'
  import {getDetail, getCommentList, chooseTeacher, checkStudentBind} from '@/api/teacher/teacherInfo'
  import {getDictName} from '@/utils/common'
  import {handlePageData} from '@/utils/common'
  import remark from "./components/remark";

  export default {
    name: 'TeacherDetail',
    components: {
      remark
    },
    data() {
      return {
        val: 5,
        genderList: [{value: '0', label: '女'}, {value: '1', label: '男'}, {value: '2', label: '未知'},],
        fileDisplayPrefix: FILE_DISPLAY_PREFIX,
        id: '',
        activityId: '',
        record: {},
        facultyTypeOptions: [],
        commentData: {
          records: [],
          current: 1,
          size: 10,
          total: 0,
          hasMore: true,
          loading: false,
          topLoading: false,
          bottomLoading: false
        },
        queryParams: {},
        getDictName,
        loading: false,
        notSelect: true
      }
    },
    computed: {},
    created() {
      this.id = this.$route.query.id;
      this.activityId = this.$route.query.activityId
      this.getDict();
      this.refresh()

      // 检查学生是否已经绑定教师
      checkStudentBind(this.activityId).then(res => {
        if (res.code === 10000) {
          this.notSelect = res.result || false
          if (this.notSelect) {
            this.$toast('已选定导师')
          }
        }
      })
    },
    mounted() {
    },
    methods: {
      refresh() {
        this.reset();
        this.getDetailInfo()
      },
      // 加载数据
      onLoad() {
        if (this.commentData.current > 1 && this.commentData.hasMore) {
          this.getCommentInfoList()
        }
      },
      refreshComment() {
        this.reset();
        this.getCommentInfoList()
      },
      chooseTeacher(remark) {
        this.record.chooseRemark = remark
        chooseTeacher(this.record.teacherCode, this.activityId, remark).then(res => {
          if (res.code === 10000) {
            this.$toast(res.msg)
          }
        }).finally(() => {
          setTimeout(() => {
            this.refresh()
          }, 100)
        })
      },
      getDetailInfo() {
        // 教师详情
        getDetail(this.id, this.activityId).then(res => {
          if (res.code === 10000) {
            this.record = res.result
          }
        }).finally(() => {
          setTimeout(() => {
            this.loading = false
          }, 100)
        });
        this.getCommentInfoList()
      },
      getCommentInfoList() {
        // 评论信息列表
        if (this.commentData.loading) return;
        this.commentData.loading = true;
        this.queryParams.teacherId = this.id;
        this.queryParams.current = this.commentData.current;
        this.queryParams.size = this.commentData.size;
        getCommentList(this.queryParams).then(res => {
          if (res.code === 10000) {
            setTimeout(() => {
              handlePageData(this.commentData, res.result)
            }, 100)
          }
        }).finally(() => {
          setTimeout(() => {
            this.commentData.loading = false;
            this.commentData.topLoading = false;
            this.commentData.bottomLoading = false
          }, 100)
        })
      },
      getDict() {
        // 查询字典，院系类型
        getDictByType('faculty_type').then(res => {
          if (res.code === 10000) {
            this.facultyTypeOptions = res.result.map(item => {
              return {label: item.dictKey, value: item.dictValue}
            })
          }
        });
      },
      reset() {
        this.commentData.current = 1;
        this.commentData.total = 0;
        this.commentData.hasMore = true
      },
      toComment(id) {
        this.$router.push({path: `/teacher/comment?id=${id}`})
      }
    }
  }
</script>

<style scoped>
/deep/.b-but .van-button{
  height:45px;
  background: #2C68E4;
  border-radius: 3px;
  width:160px;
}
.fiex-box{
  position: inherit;
}
.my-list{
  white-space: pre-wrap;
  display: flex;
  align-items: center;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1000000000;
  -webkit-box-orient: vertical;
  text-align: left;
  line-height:32px;
}
.tale-box table{
  width: 100%;
  background: #dedede;
  border-collapse: collapse;
}
.tale-box table, th, td {
  border: 1px solid #dedede; /* 细线边框的宽度和颜色 */
}
.tale-box table tr td{
  background: #ffffff;
  height: 58px;
  padding: 0 20px;
}
.infobox{
  background: #ffffff;
  margin-top: 20px;
  padding: 23px;
}
.history{
  display: flex;
  align-items: center;
}
.history h2{
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
}
.history h2 a{
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
}
.web{
  background: #f9f9f9;
  min-height: 100vh;
}

.pc-search{
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  width: 100%;
  height: 76px;
  border-bottom: 1px solid #dedede;
}
.pc-search h2{
  display: flex;
  padding: 0 20px;
  font-size:18px;
  font-weight: 600;
}
.pc-search-auto{
  width: 1134px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.pc-search-auto span{
  display: flex;
  align-items: center;
}
.pc-search-auto span img{
  width: 160px;
  height: 39px;
}
.pc-search-auto span em{
  display: flex;
  height: 26px;
  align-items: center;
  border-left: 1px solid #dedede;
  margin-left: 10px;
  padding-left: 10px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 18px;
  color: #333333;
}
.pc-search-auto h2 a{
  padding: 0 10px 0 0;
  font-size:18px;
  font-weight: 600;
}
.pc-box{
  margin: 0 auto;
}
.pc-list{
  width: 1136px;
  margin: 0 auto;
  min-height: calc(100vh - 136px);
}
.c-class{
  margin: 0 10px;
  border-bottom: 1px solid #dedede;
}
.tech-l{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;
}
.tech-list{
  margin: 0;
  border-radius: 0;
  padding: 0 15px;
  margin-bottom:1px;
  display: flex;
}
.tech-list2{
  margin: 0;
  padding: 0 15px;
  display: flex;
  width: 270px;
  height: 120px;
  background: #FCFDFD;
  border-radius: 3px;
  border: 1px solid #DEDEDE;
  margin-bottom: 16px;
  margin-right:12px;
  flex-direction: column;
}
.tech-list2:nth-child(4n){
  margin-right: 0;
}
.tech-top{
  border-bottom: 1px dashed  transparent;
  display: flex;
}
/deep/.van-tabs--line .van-tabs__wrap{
  height: 60px;
}
.tech-bottom a{
  border: 1px solid #2C68E4;
  border-radius: 100px;
  padding: 2px 8px;
  font-size: 14px;
}
.tech-bottoms{
  border-top: none;
  width: 260px;
  justify-content: flex-end;
  margin-top: 10px;
}
.tech-head .time1{
  display: block;
  margin-top: 15px;
  font-size: 14px;
  color: #999999;
}
.time2{
  display: none;
}
.tech-l em{
  position: relative;
  font-weight: bolder;
  font-size: 14px;
}
.tech-l h2{
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 18px;
  color: #333333;
  display: flex;
  align-items: center;
}
.tech-head{
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.pctime .time3{
  display: none;
}
.tech-cen {
  font-size: 12px;
  color: #666666;
  line-height: 19px;
  padding-bottom: 0;
  margin-top: 5px;
  position: relative;
  top: 0;
}
/deep/ .van-search__content{
  width: 271px;
  height: 27px;
  background: #F7F3EE;
  border-radius: 14px;
}
/deep/ .van-search__action{
  height: 27px;
  border-radius: 100px;
}
/deep/.van-field__control{
  height: 27px;
  line-height: 27px;
}
/deep/.van-tabs__nav--line{
}
/deep/.van-tab{
  flex: inherit;
}
/deep/ .van-tab span{
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 18px;
  color: #666666;
  margin-right: 30px;
}
/deep/ .van-tab--active span{
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 18px;
  color: #883032;
}
/deep/.van-tabs__line{
  left: -25px;
  width: 100px;
  height: 3px;
  background: #883032;
}
/deep/.van-list{
  display: flex;
  flex-wrap: wrap;
  padding-top: 20px;
}
.tech-list{
  width: 360px;
  height: 158px;
  background: #FCFDFD;
  border-radius: 3px;
  border: 1px solid #DEDEDE;
  margin-bottom: 16px;
  margin-right:18px;
  display: flex;
  flex-direction: column;
}
.tech-list:nth-child(3n){
  margin-right: 0;
}
.top-r{
  display: flex;
  flex-direction: column;
  width: 100%;
}
.top-r h2{
  display: flex;
  align-items: center;
  padding-top: 15px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 18px;
  color: #333333;
  margin-bottom: 15px;
}
.top-r h2 em{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 18px;
  background: #CD0005;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 12px;
  color: #FFFFFF;
  margin-left:5px;
}
.info-other{
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
}
.info-other span{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 0 0 50%;
  margin-bottom: 10px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
}
.info-item2{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
}
.tech-bottom a.qxxz{
  background: #2C68E4;
  color: #ffffff;
}
/deep/.van-button{
  height: 28px;
  text-align: center;
  justify-content: center;
  border-radius: 100px;
  margin-right: 10px;
}
.foot{
  height: 60px;
  background: #A0060E;
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
}


.pc-search h2{
  display:none;
}
/deep/ .van-list {
  padding: 0;
}

/deep/ .van-tabs__content {
  margin-top: 10px;
}

.aa {
  background: #ffffff;
}

.info-top {
  display: flex;
  padding: 10px;
}

/deep/ .info-top .van-image {
  width: 129px;
  height: 176px;
  background: #ECECEC;
  padding: 3px;
  display: flex;
  margin-right: 7px;
}

.info-r {
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-left: 20px;
}

.info-r .lang {
  display: flex;
  align-items: center;
  margin: 10px 0;
}

.info-r .lang span {
  display: flex;
  align-items: center;
  width: 50%;
  margin: 5px 0;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 18px;
  color: #666666;
}
.info-r .lang span.name{
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 32px;
  color: #333333;
}
.lang-span {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  margin: 5px 0;
}

.info-r .lang span em {
  border-radius: 3px;
  padding: 0 2px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 2px;
  width: 74px;
  height: 28px;
  background: #A82E31;
  border-radius: 3px;
}

.info-detail h2 {
  display: flex;
  align-items: center;
  font-weight: bold;
  padding:25px 0 15px 0;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 24px;
  color: #914D3B;
}

.info-detail dl {
  display: flex;
  padding: 10px 0;
  justify-content: space-between;
  border-bottom: 1px solid #EAEAEA;
}

.info-detail dl dt {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  /*display: flex;*/
  /*align-items: center;*/
  max-width: 150px;
}

.info-detail dl dd {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  flex: 1;
  text-align: right;
}

.info-detail dl.clomum {
  flex-direction: column;
}

.info-detail dl.clomum dt {
  flex-direction: column;
  max-width: 100%;
  align-items: flex-start;
  font-weight: 600;
}

.info-detail dl.clomum dd {
  white-space: pre-wrap;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1000000000;
  -webkit-box-orient: vertical;
  text-align: left;
  padding-top: 10px;
  line-height: 21px;
}

.pl-box {
  padding: 0 10px;
}

.pj-list {
  background: #FFFFFF;
  border-radius: 6px;
  margin: 10px 0;
  padding: 15px;
  display: flex;
  flex-direction: column;
}

.pl-top {
  display: flex;
  align-items: center;
}

/deep/ .pl-top .van-image {
  display: flex;
  width: 36px;
  height: 36px;
  border-radius: 100px;
  margin-right: 5px;
}

/deep/ .pl-top .van-image__error {
  display: flex;
  width: 36px;
  height: 36px;
  border-radius: 100px;
  margin-right: 5px;
}

.pl-top span {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.pl-top span h2 {
  display: flex;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  margin-bottom: 7px;
}

.pl-top span em {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #666666;
}

/deep/ .van-rate {
  display: flex;
  flex: 1;
}

/deep/ .van-rate__icon {
  font-size: 15px;
}

/deep/ .van-rate__icon--full {
  color: #6988FF;
}

.pl-bottom .pls p {
  display: flex;
  flex: 1;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 21px;
}

.pc-search{
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  height: 52px;
}
.pc-search h2{
  display: flex;
  padding: 0;
  font-size:18px;
  font-weight: 600;
  color: #999999;
}
.pc-search-auto{
  width: 1024px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.pc-search-auto h2 a{
  padding: 0 10px 0 10px;
  font-size:18px;
  font-weight: 600;
}
.pc-box{
  margin: 0 auto;
}
.aa{
  width: 1024px;
  background: none;
  margin: 0 auto;
}
.info-top{
  background: #F1F2F6;
  border-bottom: none;
  padding: 20px;
  margin-top: 20px;
}
.newheight{
  display: none;
}
.upload-a {
  color: #2C68E4;
  margin-right: 15px
}
</style>
